<template>
  <div class="wonderful-activity">
    <nav class="tip-title __fs-16 _fw-500">精选活动</nav>
    <ul>
      <li
        v-for="(item, index) in list"
        :key="index"
        @click="cbDetail(item)"
      >
        <van-image v-if="formatAliyunPath(item.src)!=false"
          class="banner-img"
          :src="formatAliyunPath(item.src)"
        />
        <div class="content">
          <p class="name">{{item.title}}</p>
          <div class="summary">{{item.summary}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'WonderfulStory',
  props: {
    list: {
      type: Array,
    }
  },
  data () {
    return {

    }
  },
  methods: {
    // 点击swiper
    cbDetail (item) {
      this.$router.push({
        path: '/building/detail',
        query: {
          id: item.id,
          type: 'activity',
        }
      })
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  },
}
</script>

<style scoped lang="scss">
.wonderful-activity {
  margin: 36px 20px 0px 20px;
  .tip-title {
    padding-left: 8px;
    border-left: 3px solid $main-color;
    border-radius: 2px;
    color: #282828;
    margin-bottom: 25px;
  }
  ul {
    width: 100%;
    white-space: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    display:-webkit-box;
    &::-webkit-scrollbar {
      display: none;
    }
    li {
      display: inline-block;
      vertical-align: top;
      width: 240px;
      white-space: pre-wrap;
      &:not(:last-child) {
        margin-right: 25px;
      }
      .banner-img {
        width: 100%;
        height: 135px;
        display: block;
      }
      .content {
        width: 100%;
        height: 100%;
        padding: 24px 12px 0 12px;
        box-sizing: border-box;
        .name {
          opacity: 1;
          font-size: 17px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: left;
          color: #252525;
          line-height: 24px;
          overflow: hidden; // 文字超过三行省略号处理
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .summary{
          margin-top: 9px;
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: left;
          color: #828282;
          line-height: 18px;
          overflow: hidden; // 文字超过三行省略号处理
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>
